import { useLocale } from "@/i18n/LocaleContext";

export const SectionLabel = ({ index, children, tone = "dark", className = "" }) => {
  const { t } = useLocale();
  return (
    <div className={`flex items-center gap-4 ${className}`} data-testid="section-label">
      <span className="h-px w-10 bg-signal" />
      {index && (
        <span
          className={`font-mono text-xs ${tone === "light" ? "text-carbon-900/40" : "text-titanium/50"}`}
          data-testid="section-label-index"
        >
          {index}
        </span>
      )}
      <span className="overline">{t(`label.${children}`, children)}</span>
    </div>
  );
};
